import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  blobData: {
    allBlobData: [],
    selectedBlobData: {},
    allEmployerData: [],
    selectedEmployerData: {},
    allLocationData: [],
    selectedLocationData: {},
  },
};

export const messageAdminSlice = createSlice({
  name: 'messageAdmin',
  initialState: INITIAL_STATE,
  reducers: {
    resetMessageAdminSlice: (state, action) => {
      state.blobData = {
        allBlobData: [],
        selectedBlobData: [],
        allEmployerData: [],
        selectedEmployerData: [],
        allLocationData: [],
        selectedLocationData: [],
      };
    },
    setBlobData: (state, action) => {
      state.blobData = { ...state.blobData, ...action.payload };
    },
    resetBlobData: (state, action) => {
      state.blobData = {
        allBlobData: [],
        selectedBlobData: [],
        allEmployerData: [],
        selectedEmployerData: [],
        allLocationData: [],
        selectedLocationData: [],
      };
    },
  },
});

export const { resetMessageAdminSlice, setBlobData, resetBlobData } =
  messageAdminSlice.actions;

export default messageAdminSlice.reducer;
